<template>
  <v-dialog persistent fullscreen v-model="showRequest" transition="dialog-bottom-transition">
    <v-card max-width="768" tile>
      <v-card-title class="justify-end px-3 py-2">
        <a @click="closeDialog()" id="btn__TBNWvxOtHkul9catx5UKsw==">
          <v-icon large> mdi-close </v-icon>
        </a>
      </v-card-title>
      <v-card-text class="text-center px-4">
        <v-row cols="12" class="mt-2" no-gutters>
          <v-col cols="12">
            <p class="mb-5 font--m-3">거래처 등록을 요청해주세요.</p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text>
        <v-card class="pb-0">
          <v-card-text class="pa-3">
            <p class="font--m-5">거래처명</p>
            <v-text-field
              outlined
              placeholder="거래처명"
              class="mb-0"
              hide-details
              v-model.trim="wholesaler.name"
            ></v-text-field>
          </v-card-text>
          <v-card-text class="pa-3">
            <p class="font--m-5">주소</p>
            <v-text-field
              outlined
              placeholder="주소"
              class="mb-0"
              hide-details
              v-model.trim="wholesaler.location"
            ></v-text-field>
          </v-card-text>
          <v-card-text class="pa-3">
            <p class="font--m-5">전화번호</p>
            <v-text-field
              outlined
              class="mb-0"
              hide-details
              v-model.trim="wholesaler.phone"
              :error="!!invalidMsg.phone"
              placeholder="예) 01012345678"
              type="tel"
              oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')"
            ></v-text-field>
            <ErrorText :text="invalidMsg.phone" nudgeLeft="4" />
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-text class="text-center black--text font-m--5 mt-5 mb-5">
        *거래처 등록 후 등록한 <b class="primary--text">거래처명으로 검색</b>하여<br />
        <b class="primary--text">송금 신청</b>할 수 있어요!
      </v-card-text>
      <v-card-actions>
        <BasicButton
          id="btn__miYhFGGM2UyLjKFRRf1aDg=="
          :disabled="registerWholesalerLoading"
          :loading="registerWholesalerLoading"
          class="pa-3"
          @click="registerWholesaler(wholesaler)"
          >등록하기</BasicButton
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Regex from '@/const/Regex'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      showRequest: true,
      wholesaler: {
        name: null,
        location: null,
        phone: null,
      },
      phoneIsValid: false,
      registerWholesalerLoading: false,
      rules: {
        phone: [
          (value) => !!value || '휴대폰 번호를 입력해주세요',
          (value) => Regex.PHONE.REGEX.test(value) || Regex.PHONE.MSG,
        ],
      },
      invalidMsg: {},
    }
  },
  watch: {
    // 'wholesaler.phone'(v) {
    //   this.checkPhone(v)
    // },
  },
  methods: {
    ...mapActions('wholesaler', ['addWholesaler']),
    async registerWholesaler(wholesaler) {
      try {
        this.registerWholesalerLoading = true
        await this.addWholesaler(wholesaler)
        this.closeDialog()
      } finally {
        this.registerWholesalerLoading = false
      }
    },
    closeDialog() {
      this.$emit('emitShow', false)
    },
    getFormErrMsg(type, newVal) {
      const rules = this.rules[type]
      let msg = null
      if (newVal) {
        for (let index = 0; index < rules.length; index++) {
          const rule = rules[index]
          const isValid = rule(newVal)
          if (typeof isValid !== 'boolean') {
            msg = isValid
            break
          }
        }
      }

      this.invalidMsg[type] = msg
      return msg
    },
    checkPhone(phone) {
      const msg = this.getFormErrMsg('phone', phone)
      if (msg === null) {
        this.phoneIsValid = true
      } else {
        this.phoneIsValid = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
